export const productTemplateReducer = (state = { loading: false, resulttemplate: null, templates: [], template: null, total: 0 }, action) => {
    switch (action.type) {
        case 'TEMPLATE_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                templates: action.payload.templates || [],
                total: action.payload.total || 0,
            }
        case 'TEMPLATE_GET_SUCCESS':
            return { ...state, loading: false, template: action.payload || null }
        case 'TEMPLATE_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resulttemplate: action.payload.message,
                template: action.payload.template,
                templates: [...state.templates, action.payload.template],
            }
        case 'TEMPLATE_EDIT_SUCCESS':
            if (action.payload.template) {
                return {
                    ...state,
                    loading: false,
                    resulttemplate: action.payload.message,
                    template: action.payload.template,
                    templates: state.templates.map(t =>
                        t._id === action.payload.template._id ? action.payload.template : t
                    ),
                }
            }
            return { ...state, loading: false, resulttemplate: action.payload.message || action.payload }
        case 'TEMPLATE_ARCHIVE_SUCCESS':
            if (action.payload.template) {
                return {
                    ...state,
                    loading: false,
                    resulttemplate: action.payload.message,
                    template: action.payload.template,
                    templates: state.templates.map(t =>
                        t._id === action.payload.template._id ? action.payload.template : t
                    ),
                }
            }
            return { ...state, loading: false, resulttemplate: action.payload.message }
        case 'TEMPLATE_IMPORT_SUCCESS':
            return {
                ...state,
                loading: false,
                resulttemplate: action.payload.message,
            }
        case 'TEMPLATE_RESET_RESULT':
            return { ...state, resulttemplate: null }
        case 'TEMPLATE_LOADING':
            return { ...state, loading: true }
        case 'TEMPLATE_ERROR':
            return { ...state, loading: false, resulttemplate: action.payload }
        default:
            return state
    }
}
